import { render, staticRenderFns } from "./ManagersHistory.vue?vue&type=template&id=1fd798a3&scoped=true"
import script from "./ManagersHistory.vue?vue&type=script&lang=js"
export * from "./ManagersHistory.vue?vue&type=script&lang=js"
import style0 from "./ManagersHistory.vue?vue&type=style&index=0&id=1fd798a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd798a3",
  null
  
)

export default component.exports